export default __webpack_public_path__ + "static/media/adonai_1.2d20989e.jpg";